<template>
  <router-view v-if="isAdminRoute"></router-view>
  <div v-else class="tdi">
    <SiteTopbar></SiteTopbar>
    <SiteHeader></SiteHeader>
    <main>
      <router-view></router-view>
    </main>
    <SiteClosing v-if="$route.meta.closing"></SiteClosing>
    <SiteFooter></SiteFooter>
    <SiteToast></SiteToast>
    <SiteNoticePopup></SiteNoticePopup>
  </div>
  <AppAlertDialog :variant="isAdminRoute ? 'legacy' : 'site'"></AppAlertDialog>
</template>

<script>
import "@fontsource/poppins";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/400-italic.css";

import SiteTopbar from './components/site/SiteTopbar.vue';
import SiteHeader from './components/site/SiteHeader.vue';
import SiteClosing from './components/site/SiteClosing.vue';
import SiteFooter from './components/site/SiteFooter.vue';
import SiteToast from './components/site/SiteToast.vue';
import SiteNoticePopup from './components/site/SiteNoticePopup.vue';
import AppAlertDialog from './components/AppAlertDialog.vue'

export default {
  name: 'App',
  components: {
    AppAlertDialog,
    SiteTopbar,
    SiteHeader,
    SiteClosing,
    SiteFooter,
    SiteToast,
    SiteNoticePopup,
  },
  mounted() {
    this.originalAlert = window.alert;
    window.alert = (message) => {
      window.dispatchEvent(new CustomEvent('app-alert', {
        detail: {
          message,
        },
      }));
    };
  },
  beforeUnmount() {
    if (this.originalAlert) {
      window.alert = this.originalAlert;
    }
  },
  computed: {
    isAdminRoute() {
      return this.$route.path.startsWith('/admin');
    },
  },
}
</script>

<style lang="scss">
body {
  margin: 0;
}

// Legacy defaults the admin area was built against; the public site (.tdi)
// sets its own type from src/styles/site.css.
#app {
  font-family: "Poppins";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#app .tdi {
  text-align: start;
}
</style>
